import {myTasksViewDictionary, MyTasksViewName, myTasksViewOptionDictionary} from "../@const";
import {ViewType} from "../../../core/gd/const/views/view-type";
import MyTasksLocalSettings from "../manager/local-settings";


export default function getDefaultMyTasksViews() {

    const myTasksLocalSettings = new MyTasksLocalSettings()


    const defaultMyTasksViews = [

        {
            id              : myTasksViewDictionary[ViewType.MY_TASKS_LIST_ACTION_REQUIRED],
            icon            : "isvg-action-required",
            name            : myTasksViewOptionDictionary[MyTasksViewName.ACTION_REQUIRED]?.label,
            sortPosition    : 0,
            type            : ViewType.MY_TASKS_LIST_ACTION_REQUIRED
        },
        {
            id              : myTasksViewDictionary[ViewType.MY_TASKS_LIST_ASSIGNED_TO_ME],
            icon            : "isvg-assigned-to-me",
            name            : myTasksViewOptionDictionary[MyTasksViewName.ASSIGNED_TO_ME]?.label,
            sortPosition    : 1,
            type            : ViewType.MY_TASKS_LIST_ASSIGNED_TO_ME
        },
        {
            id              : myTasksViewDictionary[ViewType.MY_TASKS_LIST_HIGH_PRIORITY],
            icon            : "isvg-high-priority",
            name            : myTasksViewOptionDictionary[MyTasksViewName.HIGH_PRIORITY]?.label,
            sortPosition    : 2,
            type            : ViewType.MY_TASKS_LIST_HIGH_PRIORITY
        }
    ]

    if (!!_.find(defaultMyTasksViews, { id: myTasksLocalSettings.currentView })) {

        return defaultMyTasksViews

    } else {

        defaultMyTasksViews.push({
            id              : myTasksLocalSettings.currentView,
            icon            : "isvg-action-required",
            name            : myTasksViewOptionDictionary[myTasksLocalSettings.currentView]!.label,
            sortPosition    : 3,
            type            : myTasksViewOptionDictionary[myTasksLocalSettings.currentView]!.value
        })

        return defaultMyTasksViews
    }

}
